import React, { Suspense, lazy, useState } from "react";
import { Helmet } from "react-helmet";
import Config from "../../../helpers/Config";

const BannerSlider = lazy(() => import("../../components/home/BannerSlider"));
const PopularCategories = lazy(() => import("../../components/shared/PopularCategories"));
const HomeProducts = lazy(() => import("../../components/products/HomeProducts"));
const NewProducts = lazy(() => import("../../components/products/NewProducts"));
const CompaignSection = lazy(() => import("../../components/shared/CompaignSection"));
const CompactCampaignSection = lazy(() => import("../../components/shared/CompactCampaignSection"));
const PopularProducts = lazy(() => import("../../components/products/PopularProducts"));
const BestFacilities = lazy(() => import("../../components/shared/BestFacilities"));
const SubscribeNewsLetter = lazy(() => import("../../components/shared/SubscribeNewsLetter"));


const Home = () => {
    const [siteTitle, setSiteTitle] = useState(Config['SITE_TTILE']);


    const handleBannerButtonClickUrl = (url) => {
            
        if (url != undefined && url != null && url.length > 0) {
            window.location.href = url;
        } else {
            return false;
        }

    }

    return (
        <>

            <Helmet>
                <title>{siteTitle} - Home</title>
                <meta name="description" content={siteTitle + " - Home"} />
                <meta name="keywords" content="Home"></meta>
            </Helmet>

           
            <Suspense fallback={<div>Loading...</div>}>
    <BannerSlider handleBannerButtonClickUrl={handleBannerButtonClickUrl} />
    <PopularCategories />
    <CompaignSection />
    <HomeProducts />
    <CompactCampaignSection />
    <NewProducts />
    <PopularProducts />
    <BestFacilities />
    <SubscribeNewsLetter />
</Suspense>
        </>
    );

}

export default Home;


